module.exports = __webpack_public_path__ + "img/zzf_chart_hose_back.c079af07.png";